import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';

@Component({
  selector: 'app-mobile-get-started',
  standalone: true,
  imports: [CommonModule, CarouselModule],
  templateUrl: './mobile-get-started.component.html',
  styleUrl: './mobile-get-started.component.scss'
})
export class MobileGetStartedComponent {
  @Input() getStartedItems: { title: string; description: string; image: string }[] = [];
}
